import { NavLink } from 'react-router-dom';

function BottomNav({ permissions = [], isAdmin = false, hasStores = true }) {
  let menuItems;

  if (isAdmin) {
    if (!hasStores) {
      menuItems = [
        { path: '/stores', label: '商户', icon: '🏪' },
        { path: '/system', label: '系统', icon: '⚙️' }
      ];
    } else {
      menuItems = [
        { path: '/dashboard', label: '工作台', icon: '🏠' },
        { path: '/customers', label: '客户', icon: '👥' },
        { path: '/services', label: '服务', icon: '🔧' },
        { path: '/dietary', label: '膳食', icon: '🥗' },
        { path: '/orders', label: '订单', icon: '📋' },
        { path: '/marketing', label: '营销（待完善）', icon: '📢' },
        { path: '/stores', label: '商户', icon: '🏪' },
        { path: '/system', label: '系统', icon: '⚙️' }
      ];
    }
  } else {
    menuItems = [
      { path: '/dashboard', label: '工作台', icon: '🏠' },
      { path: '/customers', label: '客户', icon: '👥' },
      { path: '/services', label: '服务', icon: '🔧' },
      { path: '/dietary', label: '膳食', icon: '🥗' },
      { path: '/orders', label: '订单', icon: '📋' },
      { path: '/marketing', label: '营销（待完善）', icon: '📢' },
    ];
  }

  return (
    <div className="bottom-nav">
      {menuItems.map(item => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => isActive ? 'bottom-nav-item active' : 'bottom-nav-item'}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </NavLink>
      ))}
    </div>
  );
}

export default BottomNav;
